export default "__VITE_ASSET__BgKvJ30o__"